import { config } from "process";
import { useEffect, useRef, useState } from "react";
import { EntityConfig, PropConfig } from "../../types/EntityConfig";

export type useFormType = {
    state: any,
    update: (e: any, key: string, type?:"id" | "text" | "multi-select" | "select" | "number" | "enum" | "date" | "boolean" | "multiple-create" | "percentage" | "anexos" , separateValueUpdateOptions?: any) => void,
    set: (rawEntity: any) => void,
    init: ()=> void,
    reStart: (newFormConfigs: EntityConfig) => void
}



// TODO get rid of this!!!!!!!
export default function useForm({ initialData = {}, formConfigs, filterMode }: { initialData?: any, formConfigs?: EntityConfig, filterMode?: boolean }) : useFormType {

    const [state, setState] = useState<any>({});

    const [configs, setConfigs] = useState<any>(formConfigs ? formConfigs : null);

    const [previousConfigs, setPreviousConfigs] = useState<any>(formConfigs ? formConfigs : null); 

    const reStart = (newFormConfigs: EntityConfig) => {
        setConfigs(newFormConfigs);
    }

    useEffect(()=> {
    
        init();
        setPreviousConfigs(formConfigs);
        

    }, [])

    useEffect(()=> {
        if(previousConfigs != configs) {
            init();
            setPreviousConfigs(formConfigs);
        }

    }, [formConfigs])




    const init = () => {

        const obj: any = {}
        if(filterMode) {
            configs?.forEach((c: any) => obj[c.id] = null);
            setState(obj);
            return;
        }    

        configs?.forEach((c: any) => {
                
             
                if (c.type === 'boolean') {
                    obj[c.id] = initialData[c.id] ? initialData[c.id] : false
                } else if (c.type === 'date') {
                    obj[c.id] = initialData[c.id] ? initialData[c.id] : new Date().toISOString().split('T')[0];
                } else if (c.type === 'select') {
                    obj[c.id] = initialData[c.id] ? initialData[c.id][c.options.value] : null;
                } else if (c.type === 'enum') {
                    obj[c.id] = initialData[c.id] ? initialData[c.id] : '';
                } else {
                    obj[c.id] = initialData[c.id] ? initialData[c.id] : null;
                }
            })

            set(obj);
    }



    const update = async (e: any, key: string, type?: "multi-select" | "select" | "number" | "enum" | "date" | "boolean" | "multiple-create" | "percentage"  , separateValueUpdateOptions?: any) => {
        const newObj: any = {};
        const typeIndex = configs?.findIndex((c:any) => c.id === key);
        if (typeIndex === -1 || typeIndex === undefined) return;
        const config: PropConfig | null = configs ? configs[typeIndex] : null;
        if (!config) return;
        newObj[key] = bootstrapValue(type, e, config);

        if (separateValueUpdateOptions)
            await handleSetSeparateValueOnChange(newObj, state,key, separateValueUpdateOptions)
        setState({ ...state, ...newObj });
    }

    const set = (rawEntity: any) => {
        const newObj: any = {};
        Object.entries(rawEntity).map(([entityProperty, propertyValue]: any[]) => {
            const typeIndex = configs?.findIndex((c: any) => c.id === entityProperty);
            if (typeIndex === -1 || typeIndex === undefined) return;
            const config: PropConfig | null = configs ? configs[typeIndex] : null;
            if (!config) return;
            const type: PropConfig["type"] | undefined = config.type;
            newObj[entityProperty] = bootstrapValue(type, propertyValue, config);
        })
        setState({ ...newObj })
    }

    const handleSetSeparateValueOnChange = async (obj: any, state: any, key: string, options: any) => {
        console.log("Handling separate value compute")
        switch (options.operation) {
            case 'sum':
                obj[options.outputField] = obj[key].reduce((prev: number, v: any) => prev + v[options.inputField], 0)
                break;
            default:
                await options.operation(obj, state);

                break;
        }
    }


    return { state, update, set, init, reStart } as useFormType;
}


const bootstrapValue = (type: PropConfig["type"] | undefined, rawValue: any, config: PropConfig) => {
  
    let value;
    if(type=== 'boolean') {
        value = rawValue?.target?rawValue.target.checked : rawValue;
    } else if (type === 'number') {
        value = rawValue?.target? parseFloat(rawValue.target.value) : rawValue;
    } else if (type === 'select') {
        value = rawValue;
    } else if (type === 'multi-select') {
        value = rawValue?.length ?  [...rawValue] : [];
    } else if (type === 'date') {
        value = new Date(rawValue).toISOString().split('T')[0];
    } else if (type == 'multiple-create') {
        value = rawValue? [...rawValue] : [];
    } else if(type == 'anexos') {
        value = rawValue? [...rawValue] : [];
    }else {
        value = rawValue?.target? rawValue.target.value :  rawValue;
    }
    return value;

}